import { useState } from "react";
import Column from "@amzn/meridian/esm/components/column";
import Divider from "@amzn/meridian/esm/components/divider";
import Expander from "@amzn/meridian/esm/components/expander";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme";
import OutlineCard from "../../OutlineCard";

const CollapsibleCard = ({ title, summary, detail }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <OutlineCard title={title}>
      <Column spacing="none">
        {summary && <Text type="b200">{summary}</Text>}
        <Theme tokens={{ expanderFontSize: 14, expanderLineHeight: "10px", expanderSpacingHorizontal: 0 }}>
          <Expander type="inline" title={expanded ? "Show less" : "Show more"} open={expanded} onChange={setExpanded}>
            {/* Pull the body back to the card edge; Meridian indents it under the chevron. */}
            <div style={{ marginLeft: -14 }}>
              <Column spacing="100">
                <Divider />
                <Text type="b200">{detail}</Text>
              </Column>
            </div>
          </Expander>
        </Theme>
      </Column>
    </OutlineCard>
  );
};

export default CollapsibleCard;
